import React, { useState, useEffect } from 'react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Michael T.",
      title: "Professional Trader",
      quote: "After 15 years of trading manually, HON-SONAR™ has revolutionized my approach. The pattern detection is remarkably accurate, and the risk management features have significantly improved my performance."
    },
    {
      name: "Sarah K.",
      title: "Institutional Trader",
      quote: "The Pattern Consensus Technology alone is worth the investment. No more second-guessing chart patterns—HON-SONAR™ validates them across multiple timeframes with impressive accuracy."
    },
    {
      name: "David R.",
      title: "Fund Manager",
      quote: "What impressed me most is how HON-SONAR™ adapts to different market conditions. It's like having a veteran analyst working for you 24/7."
    },
    {
      name: "Jennifer L.",
      title: "Proprietary Trader",
      quote: "The real-time notifications and regime detection have been game-changers for my trading strategy. I can confidently trade across multiple timeframes with HON-SONAR™."
    },
    {
      name: "Robert W.",
      title: "Independent Trader",
      quote: "I've tried many trading systems, but HON-SONAR™ stands out with its intelligent pattern recognition and risk management. My win rate has improved dramatically."
    }
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  
  // Auto-advance slides
  useEffect(() => {
    let interval;
    if (isAutoPlaying) {
      interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % testimonials.length);
      }, 5000); // Change slide every 5 seconds
    }
    return () => clearInterval(interval);
  }, [isAutoPlaying, testimonials.length]);
  
  // Navigation functions
  const goToSlide = (index) => {
    setCurrentSlide(index);
    setIsAutoPlaying(false); // Pause when manually navigating
    setTimeout(() => setIsAutoPlaying(true), 5000); // Resume after 5 seconds
  };

  return (
    <section className="py-16 bg-gray-50 w-full" id="testimonials">
      <div className="w-full px-4">
        {/* Top header section - centered */}
        <div className="text-center mb-12">
          {/* Testimonials badge with line */}
          <div className="flex items-center justify-center mb-5">
            <span className="py-1 px-6 bg-indigo-100 text-indigo-600 font-semibold text-sm rounded-full">TESTIMONIALS</span>
            <div className="h-0.5 w-12 bg-indigo-600 ml-3"></div>
          </div>
          
          {/* Header text */}
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">What Traders Are Saying</h2>
          <p className="text-lg text-gray-600 mb-5 mx-auto">
            Discover how HON-SONAR™ has transformed trading outcomes for professionals worldwide
          </p>
          
          {/* Blue accent line below text */}
          <div className="w-16 h-1 bg-indigo-600 rounded-full mx-auto"></div>
        </div>
        
        {/* Testimonial carousel - full width */}
        <div className="w-full mx-auto relative mb-8 overflow-hidden">
          {/* Slides container with transition */}
          <div 
            className="flex w-full transition-transform duration-500 ease-in-out"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {testimonials.map((testimonial, index) => (
              <div key={index} className="w-full flex-shrink-0 flex justify-center px-4">
                <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-200 w-full max-w-4xl">
                  <p className="text-gray-700 italic mb-6">{testimonial.quote}</p>
                  
                  <div className="flex items-center">
                    <div className="h-12 w-12 rounded-full bg-indigo-100 flex items-center justify-center">
                      <span className="text-indigo-600 font-bold">{testimonial.name.charAt(0)}</span>
                    </div>
                    <div className="ml-4">
                      <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                      <p className="text-indigo-600 text-sm">{testimonial.title}</p>
                    </div>
                    <div className="ml-auto">
                      <div className="flex">
                        {[...Array(5)].map((_, i) => (
                          <svg key={i} className="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                          </svg>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        {/* Navigation indicators - centered below carousel */}
        <div className="flex justify-center mt-6 space-x-1.5">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-2.5 h-2.5 rounded-full transition-all ${
                currentSlide === index 
                  ? 'bg-blue-700 w-6' 
                  : 'bg-blue-500'
              }`}
              aria-label={`Go to testimonial ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;